import React from 'react'
import { Navigate, useNavigate } from 'react-router-dom'
import { CLIENT_ROUTES } from 'src/constants/routes'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useQuery } from 'src/utils/hooks/useQuery'
import { LoadingPage } from 'src/pages/LoadingPage'
import { getAuthToken } from 'src/selectors/auth'
import { SetAuthToken, SetIsTokenSignIn } from 'src/constants/actionTypes'

export const ClientSignInWithTokenPage = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const authToken = useSelector(getAuthToken)

  const { getQuery } = useQuery()

  const longLiveToken = getQuery('long_live_token')

  useEffect(() => {
    if (!longLiveToken) {
      return
    }

    if (authToken === longLiveToken) {
      navigate(CLIENT_ROUTES.HOME_URL)

      return
    }

    if (authToken) {
      dispatch(SetAuthToken.request(null))
      dispatch(SetIsTokenSignIn.request(null))

      return
    }

    dispatch(SetAuthToken.request(longLiveToken))
    dispatch(SetIsTokenSignIn.request(true))
  }, [authToken, longLiveToken])

  if (!longLiveToken) {
    return <Navigate to={CLIENT_ROUTES.NOT_FOUND_URL} />
  }

  return <LoadingPage flow="client" />
}
